<template>
  <CommonWrapperLayout :perform-emits="true" @ready="handleReadyState">
    <template v-if="isPageContentHidden">
      <ResumeGameModal
        v-if="isResumeGameModalOpen"
        @start:newGame="handleStartNewGameFromResumeGameModal"
      />

      <PreGameSection
        v-else-if="isPreGameVisible"
        @hide:preGame="handleHidePreGame"
      />
    </template>

    <template v-else>
      <TheHeader />

      <RouterView />

      <TheFooter />
    </template>
  </CommonWrapperLayout>
</template>

<script setup>
import { onUnmounted, ref } from 'vue';
import CommonWrapperLayout from '@/components/layout/CommonWrapperLayout.vue';
import TheHeader from '@/components/header/TheHeader.vue';
import TheFooter from '@/components/footer/TheFooter.vue';
import ResumeGameModal from '@/components/modal/game/ResumeGameModal.vue';
import PreGameSection from '@/components/section/PreGameSection.vue';
import useNotificationStore from '@/store/modules/notification.js';
import useGameStore from '@/store/modules/game.js';
import usePreGameHook from '@/hooks/usePreGame.js';
import useModalHook from '@/hooks/useModal.js';
import useExecutionChainHook from '@/hooks/useExecutionChain.js';

const notificationStore = useNotificationStore();
const gameStore = useGameStore();

const { isPreGameVisible, launchNewGameFlow, hidePreGame } = usePreGameHook();

const [isResumeGameModalOpen, openResumeGameModal, closeResumeGameModal] = useModalHook();

const isPageContentHidden = ref(true);


const initNotificationStompClient = (executionChainController) => {
  notificationStore.createNotificationStompClient();
  notificationStore.connectNotificationStompClient();

  executionChainController.next();
};

const checkGameStatus = (executionChainController) => {
  if (gameStore.isGameInProgress) {
    gameStore.setIsGameInProgress(false);

    openResumeGameModal({
      afterHideCallback: () => {
        executionChainController.next();
      },
    });
  } else {
    executionChainController.next();
  }
};

const showPageContent = (_executionChainController) => {
  isPageContentHidden.value = false;
};

const handleReadyState = () => {
  const { executionChainController } = useExecutionChainHook([
    initNotificationStompClient,
    checkGameStatus,
    showPageContent,
  ]);

  executionChainController.value.launch();
};

const handleHidePreGame = ({ canProceed }) => {
  hidePreGame();

  if (!canProceed) {
    isPageContentHidden.value = false;
  }
};

const handleStartNewGameFromResumeGameModal = async () => {
  await closeResumeGameModal({ immediate: true });

  launchNewGameFlow();
};

onUnmounted(() => {
  notificationStore.clearNotificationSocket();
});
</script>
